import React from 'react';
import YokaiForm from './components/YokaiForm';
import YokaiDisplay from './components/YokaiDisplay';
import ImageModal from './components/ImageModal';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorDisplay from './components/ErrorDisplay';
import { YokaiInput } from './types/yokai';
import { useYokaiGenerator } from './hooks/useYokaiGenerator';
import { useImageModal } from './hooks/useImageModal';
import { logger } from './utils/logger';
import { config } from './constants/config';
import styles from './App.module.css';

const App: React.FC = () => {
  // カスタムフックを使用して状態管理を分離
  const {
    yokaiData,
    isLoading,
    error,
    progress,
    generateYokai,
    clearError,
    retry
  } = useYokaiGenerator({
    onSuccess: (yokaiData) => {
      logger.userAction('妖怪生成成功', { name: yokaiData.name });
    },
    onError: (error) => {
      logger.userAction('妖怪生成失敗', { error: error.message });
    }
  });

  const {
    selectedImage,
    handleImageClick,
    closeModal,
    downloadImage,
    isDownloading
  } = useImageModal();

  const handleFormSubmit = async (input: YokaiInput) => {
    logger.userAction('フォーム送信', input);
    await generateYokai(input);
  };


  return (
    <ErrorBoundary>
      <div className={styles.app}>
        <header className={styles.appHeader}>
          <h1>町隠妖怪発見器</h1>
          <p>町に隠れている妖怪を探せ…！</p>
          {config.isTestMode && (
            <div className={styles.testModeIndicator}>
              🧪 テストモード（ダミーデータ使用）
            </div>
          )}
        </header>

        <main className={styles.appMain}>
          <div className={styles.appContainer}>
            <div className={styles.formSection}>
              <YokaiForm 
                onSubmit={handleFormSubmit} 
                isLoading={isLoading} 
              />
            </div>

            <div className={styles.contentSection}>
              <ErrorDisplay 
                error={error} 
                type="api" 
                onRetry={retry}
                onDismiss={clearError}
              />
              <YokaiDisplay 
                yokaiData={yokaiData}
                isLoading={isLoading}
                error={null}
                progress={progress}
                onImageClick={(url, index) => handleImageClick(url, index, yokaiData?.name)}
              />
            </div>
          </div>
        </main>

        <ImageModal
          selectedImage={selectedImage}
          onClose={closeModal}
          onDownload={downloadImage}
          isDownloading={isDownloading}
        />
      </div>
    </ErrorBoundary>
  );
};

export default App;
